import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import MuiTextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import Icon from "../Icon/Icon";

const StyledSearchInput = styled(MuiTextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    fontSize: "0.88rem",
    "& fieldset": {
      borderColor: "#e2e8f0",
    },
    "&:hover fieldset": {
      borderColor: "#cbd5e1",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#2563eb",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "0.65rem 0.85rem",
  },
}));

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search",
  disabled = false,
  className,
  id,
  name,
  onKeyDown,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <StyledSearchInput
      id={id}
      name={name}
      className={className}
      value={value}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon name="search" fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
};

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onKeyDown: PropTypes.func,
};

export default SearchInput;
